import { render, staticRenderFns } from "./TheNavbarToolsPanelSpatialBookmarks.vue?vue&type=template&id=c3aaced0&scoped=true&"
import script from "./TheNavbarToolsPanelSpatialBookmarks.vue?vue&type=script&lang=js&"
export * from "./TheNavbarToolsPanelSpatialBookmarks.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarToolsPanelSpatialBookmarks.vue?vue&type=style&index=0&id=c3aaced0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aaced0",
  null
  
)

export default component.exports